/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { openGlobalModal, IModalData, IDialogOptions } from 'app/shared/elements/ess-global-modal';
import { RouteConfig } from 'aurelia-router';
import { guid } from 'app/shared/lib/guid';
import * as Core from 'app/core/models/essette-api';

interface IImportJobSummaryModelData {
    importJob: Core.ImportJob;
}

@autoinject()
export class JobDetailSummaryCustomElement extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable
    protected importJobId: string | null = null;

    @bindable
    protected importJobSystemCode: string | null = null;

    protected importJob: Core.ImportJob | null = null;

    ////****************** Element References ***************************************////


    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        ...rest: any[]) {

        super(...rest);
        this.logger.source = this;
    }

    protected async activate(model: IImportJobSummaryModelData, routeConfig: RouteConfig): Promise<void> {
        if(!model) { return; }

        if(model.importJob) {
            this.importJob = model.importJob;
        }
        if(this.importJob?.stagedSystemCode && this.importJob?.stagedJobIdentifier) {
            this.importJobSystemCode = this.importJob.stagedSystemCode;
            this.importJobId = this.importJob.stagedJobIdentifier;
        }
    }


    ////****************** Events ***************************************************////


    ////****************** Functions ************************************************////


    ////****************** Service Calls ********************************************////


}

/**
 * Opens the import job summary modal with the global dialog
 * @param importJob The job information to use
 */
export function openJobDetailSummary(importJob: Core.ImportJob): void {
    if(!importJob || !importJob.stagedJobIdentifier || !importJob.stagedSystemCode) {
        throw new Error('Job is missing or invalid');
    }

    const dialogOptions: IDialogOptions = {
        width: '10',
        height: '10',
        helpTopic: 'core.imports.job.summary',
        title: {
            key: 'core:routes.imports.summary.$title',
            replace: { display: importJob.stagedJobIdentifier }
        },
        print: true,
        popout: {
            route: `core.imports.job.summary`,
            params: {
                systemCode: importJob.stagedSystemCode,
                stagedJobIdentifier: importJob.stagedJobIdentifier
            }
        }
    };
    const modelData: IImportJobSummaryModelData = {
        importJob: importJob
    };

    const modalData: IModalData = {
        componentId: 'app/core/components/summary/job/job-detail-summary',
        modelData: modelData,
        dialogOptions: dialogOptions
    };

    openGlobalModal(modalData);
}
